import React from 'react';
import { useIsMobile } from '../../../hooks/useIsMobile';

interface BookReaderMessageProps {
    message: string;
}

const BookReaderMessage: React.FC<BookReaderMessageProps> = ({ message }) => {
    const isMobile = useIsMobile();

    return (
        <div
            className={`relative overflow-hidden border border-[rgba(25,207,122,0.2)] ${
                isMobile ? 'rounded-[20px]' : 'rounded-[24px]'
            }`}
            style={{
                background: 'linear-gradient(159.37deg, rgba(25,207,122,0.1) 0%, rgba(0,214,149,0.05) 100%)',
            }}
        >
            {/* 상단 그라디언트 바 */}
            <div
                className="absolute top-0 left-0 right-0 h-[4px]"
                style={{ background: 'linear-gradient(90deg, #19cf7a 0%, #00d695 100%)' }}
            />
            <div
                className={`flex flex-col gap-5 text-center ${
                    isMobile ? 'px-8 pt-8 pb-8' : 'px-20 pt-14 pb-12'
                }`}
            >
                <p
                    className={`font-bold text-[#14213d] ${
                        isMobile ? 'text-[20px]' : 'text-[32px]'
                    }`}
                >
                    독자에게 전하는 메시지
                </p>
                <p
                    className={`font-namsan text-[#333] whitespace-pre-line ${
                        isMobile ? 'text-[16px] leading-[30px]' : 'text-[20px] leading-[1.9]'
                    }`}
                >
                    "{message ? message.trim().replace(/^"+/, '').replace(/"+$/, '').trim() : ''}"
                </p>
            </div>
        </div>
    );
};

export default BookReaderMessage;
